import React, { useState } from 'react';
import './Accordion.css';

function Accordion({
  title,
  children,
  defaultExpanded = false,
  style,
  className,
}) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={`accordion ${className || ''}`} style={style}>
      <button
        className='accordion-header'
        onClick={toggleExpanded}
        aria-expanded={isExpanded}
      >
        <span className='accordion-title'>
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M19.8196 18.1464C21.27 16.3838 22.145 14.1229 22.1538 11.6562C22.174 6.03187 17.5802 1.38449 11.9998 1.38461C6.41648 1.38474 1.88578 5.92667 1.84645 11.5445C1.80711 17.1625 6.31984 21.7938 11.8938 21.8514C12.8191 21.861 13.7161 21.7454 14.5694 21.5209C15.0509 21.3942 15.5616 21.4601 15.9921 21.7117C16.5972 22.0654 17.2924 22.3728 17.9908 22.5765C18.726 22.7909 19.3955 22.0817 19.1622 21.3471C18.9763 20.7619 19.0183 20.1757 19.1207 19.6258C19.2222 19.0802 19.468 18.5736 19.8196 18.1464Z'
              fill='#7F9AE6'
            />
            <path
              d='M19.1005 21.3585C18.9153 20.7786 18.9571 20.1976 19.0591 19.6526C19.1604 19.112 19.4053 18.61 19.7556 18.1866C20.3518 17.466 20.8501 16.6612 21.2308 15.7928C13.4023 19.8321 3.94587 12.565 8.81522 2.07693C4.79109 3.3967 1.87789 7.17681 1.84645 11.6441C1.80725 17.2115 6.3039 21.8012 11.858 21.8583C12.7801 21.8678 13.6738 21.7532 14.5241 21.5307C15.0039 21.4052 15.5128 21.4705 15.9417 21.7199C16.5447 22.0704 17.2373 22.375 17.9333 22.5769C18.6658 22.7893 19.333 22.0865 19.1005 21.3585Z'
              fill='#708BD5'
            />
            <path
              d='M13.509 15.6974V9.2738C13.509 8.72451 12.9476 8.35393 12.4425 8.56981C11.8831 8.80893 11.2856 8.94676 10.6779 8.97692L9.67599 9.02662C9.44176 9.03826 9.25781 9.23155 9.25781 9.46606V10.0928C9.25781 10.3358 9.45481 10.5328 9.6978 10.5328H10.577C10.7784 10.5328 10.9416 10.6961 10.9416 10.8975V15.6973H10.0415C9.60872 15.6973 9.25781 16.0482 9.25781 16.4811V16.8002C9.25781 17.233 9.60868 17.5839 10.0415 17.5839H14.4091C14.8419 17.5839 15.1928 17.233 15.1928 16.8002V16.4811C15.1928 16.0482 14.8419 15.6973 14.4091 15.6973L13.509 15.6974Z'
              fill='#F0F2FF'
            />
            <path
              d='M12.2251 7.07397C12.934 7.07397 13.5087 6.49926 13.5087 5.79031C13.5087 5.08137 12.934 4.50665 12.2251 4.50665C11.5161 4.50665 10.9414 5.08137 10.9414 5.79031C10.9414 6.49926 11.5161 7.07397 12.2251 7.07397Z'
              fill='#F0F2FF'
            />
          </svg>

          {title}
        </span>
        <svg
          className={`accordion-icon ${isExpanded ? 'expanded' : ''}`}
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
        >
          <mask
            id='mask0_236_21382'
            style={{ maskType: 'alpha' }}
            maskUnits='userSpaceOnUse'
            x='0'
            y='0'
            width='24'
            height='24'
          >
            <rect
              x='24'
              width='24'
              height='24'
              transform='rotate(90 24 0)'
              fill='white'
            />
          </mask>
          <g mask='url(#mask0_236_21382)'>
            <path
              d='M22.5 15.3952C22.5 16.0402 22.2623 16.6857 21.784 17.1901C20.7938 18.2325 19.1465 18.2741 18.1047 17.2833L11.9818 11.4551L5.9013 17.2773C4.86317 18.2718 3.21585 18.2353 2.22198 17.1956C1.22811 16.1554 1.26507 14.5067 2.30366 13.5122L10.1766 5.9723C11.1805 5.01114 12.7616 5.00931 13.7687 5.96636L21.6909 13.5058C22.228 14.0188 22.5 14.7054 22.5 15.3952Z'
              fill='#4674B9'
            />
          </g>
        </svg>
      </button>
      <div
        className={`accordion-content-wrapper ${
          isExpanded ? 'expanded' : 'collapsed'
        }`}
      >
        <div className='accordion-content'>{children}</div>
      </div>
    </div>
  );
}

export default Accordion;
